import { gql } from "@apollo/client";

export const REGISTER_USER = gql`
    mutation RegisterUser($registerInput: CreateUserInput!) {
        registerUser(registerInput: $registerInput)
    }
`


export const LOGIN_USER = gql`
    mutation LoginUser($loginInput: LoginUserInput!) {
        loginUser(loginInput: $loginInput) {
            access_token
            refresh_token
            user {
                _id 
                paid
                planType
                firstName
                lastName
                profileImage
                mobile
                email
                role
                roleName
                expirationDate
                textProvider
                tested
                smtpTested
                planExpired
                isActive
                softDelete
            }
        }
    }
`

export const VERIFY_EMAIL = gql`
mutation ConfirmUser($confirmInput: ConfirmUserInput!) {
  confirmUser(confirmInput: $confirmInput){
    access_token
    refresh_token
    user{
      _id
      paid
      planType
      firstName
      lastName
      profileImage
      mobile
      email
      role
      roleName
      expirationDate
      textProvider
      tested
      smtpTested
      planExpired
      isActive
      softDelete
    }
  }
}
`


export const FORGOT_PASSWORD = gql`
mutation ForgotPassword($email: String!) {
  forgotPassword(email: $email)
}
`


export const RESET_PASSWORD = gql`
mutation ResetPassword($resetPasswordInput: ResetPasswordInput!) {
  resetPassword(resetPasswordInput: $resetPasswordInput)
}
`


export const CHANGE_PASSWORD = gql`
mutation ChangePassword($changePasswordInput: ChangePasswordInput!) {
  changePassword(changePasswordInput: $changePasswordInput)
}
`

export const UPDATE_PROFILE = gql`
mutation UpdateProfile($updateProfileInput: UpdateProfileInput!) {
  updateProfile(updateProfileInput: $updateProfileInput) {
    firstName
    lastName
  }
}
`


export const UPLOAD_FILE = gql`
mutation UploadProfileImage($file: Upload!) {
  uploadProfileImage(file: $file) {
    url
    key
  }
}
`

export const REMOVE_IMAGE = gql`
mutation Mutation {
  removeProfileImage
}
`